import { onMount, onCleanup, createSignal, Show, type JSX } from "solid-js";

/** Mount heavy D3 charts only when the slot is near the viewport (keeps initial load responsive). */
export default function PerformanceChartViewportSlot(props: {
  children: JSX.Element;
  /** Sidebar chart-search anchor (utils/chartSearchTargets). On the slot, so unmounted charts are findable. */
  searchTitle?: string;
  searchDetail?: string;
}) {
  const [shouldMount, setShouldMount] = createSignal(false);
  let containerRef: HTMLDivElement | undefined;
  let observer: IntersectionObserver | undefined;

  onMount(() => {
    const el = containerRef;
    if (!el) return;

    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setShouldMount(true);
          }
        }
      },
      { root: null, rootMargin: "300px 0px 300px 0px", threshold: 0 }
    );
    observer.observe(el);
  });

  onCleanup(() => observer?.disconnect());

  return (
    <div
      ref={containerRef!}
      class="performance-chart-slot"
      data-chart-search-title={props.searchTitle || undefined}
      data-chart-search-detail={props.searchDetail || undefined}
    >
      <Show when={shouldMount()} fallback={<div class="performance-chart-slot-placeholder" aria-hidden="true" />}>
        {props.children}
      </Show>
    </div>
  );
}
